export * from './ResourceDetailsHeader';
export * from './ResourceDetailsTemplate';
